// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1cFcg","title":"styles_title__DwNUj","subtitle":"styles_subtitle__2CZmr","headerWithIcon":"styles_headerWithIcon__y0JgZ"};